import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import { GatsbyImage, getImage, getSrc } from "gatsby-plugin-image"
import Link from "../components/Link"
import { options, renderLinkedIn, renderTwitter } from "../utils/richtext"
import { renderRichText } from "gatsby-source-contentful/rich-text"

const getTags = tags => {
  var tagDiv = ""
  if (tags !== null) {
    //strip space:
    const str = tags.replace(/\s+/g, "")
    //make tag divs:
    tagDiv = str.split(",").map(t => {
      return (
        <div key={t} className="tag-item">
          {t}
        </div>
      )
    })
  }
  return tagDiv
}

const blogPost = props => {
  let metaImg = getSrc(props.data.contentfulBlogPost.heroImage)
  if (props.data.contentfulBlogPost.socialMediaPreview !== null) {
    metaImg = getSrc(props.data.contentfulBlogPost.socialMediaPreview)
  }
  //const metaImg = getSrc(props.data.contentfulBlogPost.heroImage)
  const metaImgObj = { src: metaImg }
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  const customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/(.)*\//g, "")
  return (
    <Layout location={props.location}>
      <Seo
        title={props.data.contentfulBlogPost.title}
        description={props.data.contentfulBlogPost.excerpt}
        image={metaImgObj}
        pathname={`/blog/${props.data.contentfulBlogPost.slug}`}
      />
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>
      <div className="hero-header">
        <div className="hero-title">
          <h1>{props.data.contentfulBlogPost.title}</h1>
          <div className="tags">
            {getTags(props.data.contentfulBlogPost.tags)}
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-image-container">
            <GatsbyImage
              image={getImage(props.data.contentfulBlogPost.heroImage)}
              alt={props.data.contentfulBlogPost.heroImage.title}
            />
          </div>
        </div>
      </div>

      <div className="content_narrow">
        <div className="blogpost-meta">
          {props.data.contentfulBlogPost.publishDate} von{" "}
          {props.data.contentfulBlogPost.author.fullName}
        </div>
      </div>
      <div className="content_narrow">
        <div className="blogpost">
          {props.data.contentfulBlogPost.body &&
            renderRichText(props.data.contentfulBlogPost.body, options)}
        </div>

        <div className="case-cta">
          <div className="case-cta-person">
            <div className="case-cta-photo">
              {props.data.contentfulBlogPost.author.photo && (
                <GatsbyImage
                  image={getImage(props.data.contentfulBlogPost.author.photo)}
                  alt={props.data.contentfulBlogPost.author.fullName}
                  className="case-cta-img"
                />
              )}
            </div>
            <div className="case-cta-label">
              <div className="case-cta-label-name">
                {props.data.contentfulBlogPost.author.fullName}
              </div>
              <div className="case-cta-label-jobtitle">
                {props.data.contentfulBlogPost.author.jobTitle}
              </div>
            </div>
          </div>
          <div className="case-cta-description">
            <span className="case-cta-description-label">
              <h2>Haben wir Ihr Interesse geweckt?</h2>
            </span>
            <p>
              Dann kontaktieren Sie{" "}
              {props.data.contentfulBlogPost.author.fullName} gerne per Telefon
              oder E-Mail.
            </p>
            <p>
              Email:{" "}
              <Link to={`mailto:${props.data.contentfulBlogPost.author.email}`}>
                {props.data.contentfulBlogPost.author.email}
              </Link>
            </p>
            {props.data.contentfulBlogPost.author.telefon && (
              <span>
                Telefon:{" "}
                <Link
                  to={`tel:${props.data.contentfulBlogPost.author.telefon}`}
                >
                  {props.data.contentfulBlogPost.author.telefon}
                </Link>
              </span>
            )}
            <div className="social_icons">
              {props.data.contentfulBlogPost.author.linkedIn &&
                renderLinkedIn(props.data.contentfulBlogPost.author.linkedIn)}
              {props.data.contentfulBlogPost.author.twitter &&
                renderTwitter(props.data.contentfulBlogPost.author.twitter)}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default blogPost

export const query = graphql`
  query ($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      slug
      publishDate(formatString: "Do MMMM, YYYY")
      heroImage {
        gatsbyImageData(width: 2048)
        title
        description
      }
      socialMediaPreview {
        gatsbyImageData(width: 1024)
        title
        description
      }
      excerpt
      author {
        fullName
        jobTitle
        telefon
        email
        photo {
          gatsbyImageData(width: 600)
        }
        shortBio {
          raw
        }
        linkedIn
        twitter
      }
      tags
      body {
        raw
        references {
          ... on ContentfulAsset {
            __typename
            file {
              url
              contentType
            }
            contentful_id
            title
            gatsbyImageData(width: 1200)
          }
          ... on ContentfulAssetDownload {
            __typename
            contentful_id
            description
            linkedAsset {
              file {
                contentType
                fileName
                url
              }
            }
            thumbnail {
              title
              gatsbyImageData(width: 300)
            }
          }
        }
      }
    }
  }
`
